<template>
  <div class="shop-index">
    <Search :renderData="renderData" :formData="form" @onSearch="onSearch"></Search>
    <div class="fun-btn-box">
      <el-button type="primary" class="mr10" @click="onAdd">+ 录入店铺</el-button>
      <el-button class="mr10" @click="onImport">导入</el-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :offset="offset"
      :total="total"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #mallName="{ row }">{{ row.mallName }}</template>
      <template #refId="{ row }">{{ row.refId }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #category="{ row }">{{ row.category }}</template>
      <template #floor="{ row }">{{ row.floor }}</template>
      <template #disable="{ row }">
        <el-switch
          :value="!row.disable"
          active-color="#05C8AF"
          inactive-color="#F2F3F5"
          v-on:change="(value) => onStatusChange(value, row)"
        >
        </el-switch>
      </template>
      <template #contractor="{ row }">{{ row.contractor }}</template>
      <template #contractorPhone="{ row, scope }">
        <span>{{ row.contractorPhone }}</span>
        <el-button class="look-phone-btn" v-if="row.contractorPhone" type="text" @click="onLookPhone(row, scope.$index)">查看</el-button>
      </template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operatorName="{ row }">{{ row.operatorName }}</template>
      <template #operation="{ scope }">
        <!-- <el-button type="text" @click="onEdit(scope.row)">下载收款码</el-button> -->
        <el-button type="text" @click="onEdit(scope.row)">编辑</el-button>
      </template>
    </Table>
  </div>
</template>

<script>
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import {api_putChangeStatus, api_getTableList, api_putShopEdit} from '@/api/shop'
import {api_getConfig} from "../../../api/common";

export default {
  name: "shopIndex",
  mixins: [tableList],
  components: {
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "商场名称",
          placeholder: "请选择商场名称",
          type: "select",
          key: "mallId",
          option: [],
        },
        {
          label: "店铺编号",
          placeholder: "请输入店铺编号",
          type: "input",
          key: "refId",
        },
        {
          label: "店铺名称",
          placeholder: "请输入店铺名称",
          type: "input",
          key: "name",
        },
        {
          label: "所属业态",
          placeholder: "请选择所属业态",
          type: "select",
          multiple: false,
          key: "category",
          option: [],
        },
        {
          label: "店铺状态",
          placeholder: "请选择店铺状态",
          type: "select",
          key: "disable",
          option: [
            {label: "启用", value: 'false',},
            {label: "禁用", value: 'true',},
          ],
        },
      ],
      form: {},
      tableThData: [
        {prop: "mallName", label: "商场名称", minWidth: "120",},
        {prop: "refId", label: "店铺编号", minWidth: "100",},
        {prop: "name", label: "店铺名称", minWidth: "180",},
        {prop: "category", label: "所属业态", minWidth: "120",},
        {prop: "floor", label: "所在楼层", minWidth: "100",},
        {prop: "disable", label: "店铺状态", minWidth: "100",},
        {prop: "contractor", label: "负责人", minWidth: "100",},
        {prop: "contractorPhone", label: "负责人手机号", minWidth: "120",},
        {prop: "created", label: "录入时间", minWidth: "180",},
        {prop: "operatorName", label: "操作人", minWidth: "180",},
        {prop: "operation", label: "操作", minWidth: "180",},
      ],

      categoryData: [], // 所属业态数据
    };
  },
  created() {
    this.getMallData() // 获取商场数据
    this.getCategoryData() // 获取所属业态数据
  },
  methods: {
    // 获取表格列表数据
    async getList() {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      try {
        const data = await api_getTableList(params)
        this.tableTrData = data.list
        this.total = data.count
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    // 获取商场数据
    async getMallData() {
      let res = await api_getConfig('mall')
      const renderDataIndex = this.renderData.findIndex(item => item.key == 'mallId')
      res = res.mall.map(item => {
        return {
          label: item.name,
          value: item.id + ''
        }
      })
      this.renderData[renderDataIndex].option = res
    },

    // 获取所属业态数据
    async getCategoryData() {
      let res = await api_getConfig('category')
      const renderDataIndex = this.renderData.findIndex(item => item.key == 'category')
      res = res.category.map(item => {
        return {
          label: item.name,
          value: item.name
        }
      })
      this.renderData[renderDataIndex].option = res
    },

    // 点击状态切换开关
    onStatusChange(value, row) {
      this.$baseConfirm(
        `是否${value ? '启用' : '停用'}该店铺？`,
        {title: '提示', type: 'warning',},
        async () => {
          await api_putChangeStatus({id: row.id})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        })
    },

    // 点击查看手机号
    onLookPhone(row, index) {
      console.log('row: ', row);
    },

    // 点击新增按钮
    onAdd() {
      this.$router.push("/shop/index/add");
    },

    // 点击导入按钮
    onImport() {
      this.$router.push("/shop/index/import");
    },

    // 点击编辑按钮
    onEdit(row) {
      this.$router.push(`/shop/index/add?id=${row.id}`);
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.shop-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .look-phone-btn {
    font-size: 10px;
    color: #3775FF;
    margin-left: 5px;
  }

  .fun-btn-box {
    margin-top: 20px;
  }
}
</style>
